import { Component, OnInit, Renderer2, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { LoadingService } from '@shared/services/loading.service';

@Component({
  selector: 'iho-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit {

  constructor(
    // public dialogRef: MatDialogRef<LoadingComponent>,
    public loadingService: LoadingService
  ) { }

  

  renderer = inject(Renderer2)
  loading: any
  loadingTemplate: any = LoadingComponent

  ngOnInit(): void {
    this.showLoading()
  }

showLoading(){
     // this.renderer.setStyle(this.parentElement, 'position', 'relative');
    //  this.loading = this.loadingTemplate.createEmbeddedView({}).rootNodes[0];
    //  const top = this.parentElement.offsetTop - this.popup.offsetHeight;
     // const right = this.parentElement.clientWidth - this.popup.clientWidth
  //    this.renderer.setStyle(this.loading, 'top', `50%`);
  //    this.renderer.setStyle(this.loading, 'right', `50%`);
  //    this.renderer.setStyle(this.loading, 'transform', `translate(-50%, -50%)`);

  //  // this.popup.innerHTML = `<div class="flex justify-center items-center text-sm ${this.contentClass}">${this.content}</div>`
  //    this.renderer.setStyle(this.loading, 'position', 'absolute');
  //    this.renderer.setStyle(this.loading, 'font-family', 'var(--font-fa)');
  //    // this.renderer.setStyle(this.loading, 'width', `${this.width}px`);
  //    // this.renderer.setStyle(this.loading, 'height', `${this.height}px`);
  //    this.renderer.setAttribute(this.loading, "class", "bg-white rounded-xl shadow-md !z-50 p-4 border-[1px] after:!-z-10 border-gray-200 after:w-5 after:h-5 after:rotate-45 after:bg-white after:absolute after:-bottom-2 after:right-[45%] after:rounded-md mb-20 text-center")
  //    this.renderer.appendChild(document.body, this.loading);
}

hideLoading(){
  this.renderer.removeChild(document.body, this.loading
    )
}

}
